(ns practitest.frontend.components2.dashboard.charts.scales
  (:require ["d3" :as d3]))

(defn- d3-scale [scale]
  (case scale
      :temporal           (.scaleUtc d3)
      :quantitative       (.scaleLinear d3)
      (:ordinal :nominal) (.scaleBand d3)))

(defn- field-values [field data]
  (cond
    (map? data)    (mapcat #(map field %) (vals data))
    (vector? data) (map field data)))

(defn- domain
  "Returns the input range a scale maps from.

   Honors an explicit (:domain scale) when provided. Otherwise pulls all
   `field` values out of the data and reduces them by channel type:
     :ordinal/:nominal → distinct values (each gets its own slot)
     other (continuous) → [min max] via d3.extent"
  [{:keys [type field scale]} data]
  (or (:domain scale)
      (let [values (field-values field data)]
        (case type
          (:ordinal :nominal) (vec (distinct values))
          (.extent d3 (clj->js values))))))

(defn- mk-scale [{:keys [type scale] :as channel} data range]
  (-> type
      d3-scale
      (.domain (clj->js (domain channel data)))
      (.range  (clj->js (or (:range scale) range)))
      (cond->
          (:nice scale)          (.nice)
          (:clamp scale)         (.clamp true)
          (:padding scale)       (.padding (:padding scale))
          (:padding-inner scale) (.paddingInner (:padding-inner scale))
          (:padding-outer scale) (.paddingOuter (:padding-outer scale)))))

(defn- mk-color-scale
  "Returns a {series-id color} map used by marks to pick a stroke per series.

   Two data shapes:
     - map      {:planned [...] :executed [...]} → series-ids = map keys
     - vector   [{:cat :a ...} {:cat :b ...}]    → series-ids = distinct
                                                    values of `field` (e.g. :cat)

   Colors come from the channel's :scale :range, paired by position with
   the series-ids. An explicit :scale :domain overrides the inferred ids."
  [{:keys [field scale]} data]
  (let [domain (or (:domain scale)
                   (cond
                     (map? data)    (vec (keys data))
                     (vector? data) (vec (distinct (map field data)))))]
    (zipmap domain (:range scale))))

(defn with-scales
  [{{:keys [x y color]} :encode :keys [data width height] :as ctx}]
  (-> ctx
      (assoc-in [:encode :x :d3-scale] (mk-scale x data [0 width]))
      (assoc-in [:encode :y :d3-scale] (mk-scale y data [height 0]))
      (cond-> color (assoc-in [:encode :color :d3-scale]
                              (mk-color-scale color data)))))
